'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _googleMapReact = require('google-map-react');

var _googleMapReact2 = _interopRequireDefault(_googleMapReact);

var _MapMarker = require('./MapMarker');

var _MapMarker2 = _interopRequireDefault(_MapMarker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DynamicMap = function (_Component) {
  _inherits(DynamicMap, _Component);

  function DynamicMap() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DynamicMap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DynamicMap.__proto__ || Object.getPrototypeOf(DynamicMap)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clusterFactor: 10000
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DynamicMap, [{
    key: 'handleOnCenterChange',
    value: function handleOnCenterChange(_ref2) {
      var center = _ref2.center,
          zoom = _ref2.zoom,
          bounds = _ref2.bounds,
          marginBounds = _ref2.marginBounds;

      var newFactor = 10000;

      // TODO Find an algorithm
      if (zoom < 6) {
        newFactor = 0.1;
      } else if (zoom < 12) {
        newFactor = 100;
      } else if (zoom < 14) {
        newFactor = 250;
      } else if (zoom < 16) {
        newFactor = 1000;
      }

      this.setState({
        clusterFactor: newFactor
      });

      this.props.onCenterChange({
        center: center,
        zoom: zoom,
        bounds: bounds,
        marginBounds: marginBounds
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var newCenter = {
        lat: this.props.geoLatitude || this.props.centerLat,
        lng: this.props.geoLongitude || this.props.centerLng
      };

      var _props = this.props,
          apiKey = _props.apiKey,
          drawDirection = _props.drawDirection,
          events = _props.events,
          handleOnClick = _props.handleOnClick,
          initialZoom = _props.initialZoom,
          mapOptions = _props.mapOptions;

      var Marker = this.props.marker;

      var clusterFactor = this.state.clusterFactor;


      var clusteredEvents = events.reduce(function (acc, ev) {
        var clusteredLat = Math.round(ev.lat * clusterFactor) / clusterFactor;
        var clusteredLng = Math.round(ev.lng * clusterFactor) / clusterFactor;
        var key = clusteredLat + '|' + clusteredLng;

        if (!acc[key]) {
          acc[key] = []; // eslint-disable-line no-param-reassign
        }
        acc[key].push(ev);

        return acc;
      }, {});
      var eventsClusters = Object.keys(clusteredEvents).map(function (key) {
        if (clusteredEvents[key].length > 1) {
          var meanLat = clusteredEvents[key].reduce(function (acc, ev) {
            return acc + ev.lat;
          }, 0) / clusteredEvents[key].length;
          var meanLng = clusteredEvents[key].reduce(function (acc, ev) {
            return acc + ev.lng;
          }, 0) / clusteredEvents[key].length;

          return {
            id: clusteredEvents[key].reduce(function (acc, ev) {
              if (acc === '') {
                return '' + ev.id;
              }

              return acc + '-' + ev.id;
            }, ''),
            lat: meanLat,
            lng: meanLng,
            events: clusteredEvents[key]
          };
        }

        return clusteredEvents[key][0];
      });

      var orderedEvents = eventsClusters.sort(function (a, b) {
        var latDiff = b.lat - a.lat;
        var lngDiff = b.lng - a.lng;

        var lat = latDiff > 0 ? 1 : -1;
        var lng = lngDiff > 0 ? 1 : -1;

        return (drawDirection[0] === 'N' ? -lat : lat) || (drawDirection[1] === 'E' ? -lng : lng);
      });

      return _react2.default.createElement(
        'div',
        { className: 'DynamicMap' },
        _react2.default.createElement(
          _googleMapReact2.default,
          {
            bootstrapURLKeys: {
              key: apiKey,
              v: '3.30'
            },
            center: newCenter,
            defaultZoom: initialZoom,
            onChange: this.handleOnCenterChange.bind(this),
            options: mapOptions,
            style: { minHeight: '1px' } // The map does not always display without this
          },
          orderedEvents.map(function (e) {
            return _react2.default.createElement(Marker, _extends({ key: e.id + '-' + e.start_date, onClick: handleOnClick.bind(_this2, e.id) }, e));
          })
        )
      );
    }
  }]);

  return DynamicMap;
}(_react.Component);

DynamicMap.DefaultMarker = function () {
  return _react2.default.createElement(_MapMarker2.default, null);
};

DynamicMap.propTypes = {
  /** The Google Maps API key */
  apiKey: _propTypes2.default.string.isRequired,
  /** The starting latitude. */
  centerLat: _propTypes2.default.number.isRequired,
  /** The starting longitude. */
  centerLng: _propTypes2.default.number.isRequired,
  /** Order in which events are drawn. Used to manage z-indices. */
  drawDirection: _propTypes2.default.oneOf(['NW', 'NE', 'SW', 'SE']),
  /** A list of events to render. */
  events: _propTypes2.default.array.isRequired,
  /** A dynamic, overriding latitude as provided by the Geolocation API, for example */
  geoLatitude: _propTypes2.default.number,
  /** A dynamic, overriding longitude as provided by the Geolocation API, for example */
  geoLongitude: _propTypes2.default.number,
  /** Method called when clicking on a marker. */
  handleOnClick: _propTypes2.default.func,
  /** The starting zoom. */
  initialZoom: _propTypes2.default.number.isRequired,
  /** Configuration object passed to the underlying maps API. */
  mapOptions: _propTypes2.default.object,
  /** A component or node to display as a marker. */
  marker: _propTypes2.default.func,
  /** Method called when the map has moved.
   * It is recommended to fetch as far as the largest dimension
   * from the borders to ensure there are no gaps when dragging. */
  onCenterChange: _propTypes2.default.func
};
DynamicMap.defaultProps = {
  drawDirection: 'NW',
  geoLatitude: null,
  geoLongitude: null,
  handleOnClick: null,
  onCenterChange: function onCenterChange() {},
  mapOptions: {
    clickableIcons: false
  },
  marker: DynamicMap.DefaultMarker
};
exports.default = DynamicMap;
DynamicMap.__docgenInfo = {
  'description': '',
  'methods': [{
    'name': 'DefaultMarker',
    'docblock': null,
    'modifiers': ['static'],
    'params': [],
    'returns': null
  }, {
    'name': 'handleOnCenterChange',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': '{ center, zoom, bounds, marginBounds }',
      'type': null
    }],
    'returns': null
  }],
  'displayName': 'DynamicMap',
  'props': {
    'drawDirection': {
      'defaultValue': {
        'value': '\'NW\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'NW\'',
          'computed': false
        }, {
          'value': '\'NE\'',
          'computed': false
        }, {
          'value': '\'SW\'',
          'computed': false
        }, {
          'value': '\'SE\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'Order in which events are drawn. Used to manage z-indices.'
    },
    'geoLatitude': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'A dynamic, overriding latitude as provided by the Geolocation API, for example'
    },
    'geoLongitude': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'A dynamic, overriding longitude as provided by the Geolocation API, for example'
    },
    'handleOnClick': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Method called when clicking on a marker.'
    },
    'onCenterChange': {
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Method called when the map has moved.\nIt is recommended to fetch as far as the largest dimension\nfrom the borders to ensure there are no gaps when dragging.'
    },
    'mapOptions': {
      'defaultValue': {
        'value': '{\n  clickableIcons: false,\n}',
        'computed': false
      },
      'type': {
        'name': 'object'
      },
      'required': false,
      'description': 'Configuration object passed to the underlying maps API.'
    },
    'marker': {
      'defaultValue': {
        'value': 'DynamicMap.DefaultMarker',
        'computed': true
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'A component or node to display as a marker.'
    },
    'apiKey': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'The Google Maps API key'
    },
    'centerLat': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': 'The starting latitude.'
    },
    'centerLng': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': 'The starting longitude.'
    },
    'events': {
      'type': {
        'name': 'array'
      },
      'required': true,
      'description': 'A list of events to render.'
    },
    'initialZoom': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': 'The starting zoom.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/DynamicMap.js
// module id = 271
// module chunks = 0